module.exports = __webpack_public_path__ + "img/logo-bg.21bcb450.svg";